import * as Yup from "yup";
import { TLegacyUserRoleACL } from "../../../api/types/UserRole";
import { TLegacyUser } from "../../../api/types/User";

// form field names
export type TFormFieldNames =
  | "role_id"
  | "description"
  | "role_acls"
  | "users"
  | "searchACL";

// initial values for the form
export const roleDetailsInitialValues = {
  role_id: "",
  description: "",
  role_acls: [] as TLegacyUserRoleACL[],
  users: [] as TLegacyUser[],
  searchACL: "",
};

// validation schema for the form
export const roleDetailsYupValidationSchema = Yup.object().shape({
  role_id: Yup.string()
    .required("Role title is required")
    .matches(
      /^[a-zA-Z0-9\-_]+$/,
      "Only characters, numbers, hyphens, and underscores are allowed"
    ),
  description: Yup.string().required("Description is required"),
});

// Validation schema for Sysadmin role details form
export const roleDetailsSysadminValidationSchema = Yup.object().shape({
  role_id: Yup.string()
    .required("Role title is required")
    .matches(
      /^[a-zA-Z0-9\-_!@#$%^&*()+=,./<>?;:'"[\]{}|~`\\]+$/,
      "Only characters, numbers and special characters are allowed (spaces not allowed)"
    ),
  description: Yup.string().required("Description is required"),
});
